import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { ServicesGrid } from '../ui/ServicesGrid';
export function HomeServices() {
  return <section className="bg-paper" aria-labelledby="services-title" data-id="element-189" data-mp="1mdz2wvuviw7f">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-190" data-mp="1rcacr6l656pn">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-191" data-mp="1copbli7uthkd">
          <SectionHeading id="services-title" eyebrow="Executive Search & Talent Advisory" title="Search and advisory, shaped around the role." intro="From a single senior appointment to a view of an entire leadership market, each service is designed to answer a specific hiring question." data-id="element-192" data-mp="1hf5pf3fl7579" />
          <Link to="/services" className="group inline-flex shrink-0 items-center gap-2 text-sm font-medium text-navy underline-offset-4 hover:underline" data-id="element-193" data-mp="tqw565y0upi8">
            View all services
            <ArrowRightIcon className="h-4 w-4 text-gold-deep transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-194" data-mp="3vg1a25ihkghx" />
          </Link>
        </div>
        <div className="mt-14" data-id="element-195" data-mp="3e1yslq3fug4">
          <ServicesGrid data-id="element-196" data-mp="3dtmow1sot5z" />
        </div>
      </div>
    </section>;
}